/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { projectTaxesTaxSpecialCreate } from '../fn/taxes-special/project-taxes-tax-special-create';
import { projectTaxesTaxSpecialCreate$FormData } from '../fn/taxes-special/project-taxes-tax-special-create-form-data';
import { ProjectTaxesTaxSpecialCreate$FormData$Params } from '../fn/taxes-special/project-taxes-tax-special-create-form-data';
import { ProjectTaxesTaxSpecialCreate$Params } from '../fn/taxes-special/project-taxes-tax-special-create';
import { projectTaxesTaxSpecialCreate$XWwwFormUrlencoded } from '../fn/taxes-special/project-taxes-tax-special-create-x-www-form-urlencoded';
import { ProjectTaxesTaxSpecialCreate$XWwwFormUrlencoded$Params } from '../fn/taxes-special/project-taxes-tax-special-create-x-www-form-urlencoded';
import { projectTaxesTaxSpecialDestroy } from '../fn/taxes-special/project-taxes-tax-special-destroy';
import { ProjectTaxesTaxSpecialDestroy$Params } from '../fn/taxes-special/project-taxes-tax-special-destroy';
import { projectTaxesTaxSpecialPartialUpdate } from '../fn/taxes-special/project-taxes-tax-special-partial-update';
import { projectTaxesTaxSpecialPartialUpdate$FormData } from '../fn/taxes-special/project-taxes-tax-special-partial-update-form-data';
import { ProjectTaxesTaxSpecialPartialUpdate$FormData$Params } from '../fn/taxes-special/project-taxes-tax-special-partial-update-form-data';
import { ProjectTaxesTaxSpecialPartialUpdate$Params } from '../fn/taxes-special/project-taxes-tax-special-partial-update';
import { projectTaxesTaxSpecialPartialUpdate$XWwwFormUrlencoded } from '../fn/taxes-special/project-taxes-tax-special-partial-update-x-www-form-urlencoded';
import { ProjectTaxesTaxSpecialPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/taxes-special/project-taxes-tax-special-partial-update-x-www-form-urlencoded';
import { projectTaxesTaxSpecialRetrieve } from '../fn/taxes-special/project-taxes-tax-special-retrieve';
import { ProjectTaxesTaxSpecialRetrieve$Params } from '../fn/taxes-special/project-taxes-tax-special-retrieve';
import { projectTaxesTaxSpecialUpdate } from '../fn/taxes-special/project-taxes-tax-special-update';
import { projectTaxesTaxSpecialUpdate$FormData } from '../fn/taxes-special/project-taxes-tax-special-update-form-data';
import { ProjectTaxesTaxSpecialUpdate$FormData$Params } from '../fn/taxes-special/project-taxes-tax-special-update-form-data';
import { ProjectTaxesTaxSpecialUpdate$Params } from '../fn/taxes-special/project-taxes-tax-special-update';
import { projectTaxesTaxSpecialUpdate$XWwwFormUrlencoded } from '../fn/taxes-special/project-taxes-tax-special-update-x-www-form-urlencoded';
import { ProjectTaxesTaxSpecialUpdate$XWwwFormUrlencoded$Params } from '../fn/taxes-special/project-taxes-tax-special-update-x-www-form-urlencoded';
import { BackendTaxSpecialDto } from '../models/backend-tax-special-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiTaxesSpecialService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectTaxesTaxSpecialCreate()` */
  static readonly ProjectTaxesTaxSpecialCreatePath = '/api/project_taxes/tax_special/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxSpecialCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxSpecialCreate$Response(
    params: ProjectTaxesTaxSpecialCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxSpecialDto>> {
    return projectTaxesTaxSpecialCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxSpecialCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxSpecialCreate(
    params: ProjectTaxesTaxSpecialCreate$Params,
    context?: HttpContext,
  ): Observable<BackendTaxSpecialDto> {
    return this.projectTaxesTaxSpecialCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxSpecialDto>): BackendTaxSpecialDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxSpecialCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxSpecialCreate$XWwwFormUrlencoded$Response(
    params: ProjectTaxesTaxSpecialCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxSpecialDto>> {
    return projectTaxesTaxSpecialCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxSpecialCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxSpecialCreate$XWwwFormUrlencoded(
    params: ProjectTaxesTaxSpecialCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendTaxSpecialDto> {
    return this.projectTaxesTaxSpecialCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxSpecialDto>): BackendTaxSpecialDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxSpecialCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxSpecialCreate$FormData$Response(
    params: ProjectTaxesTaxSpecialCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxSpecialDto>> {
    return projectTaxesTaxSpecialCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxSpecialCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxSpecialCreate$FormData(
    params: ProjectTaxesTaxSpecialCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendTaxSpecialDto> {
    return this.projectTaxesTaxSpecialCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxSpecialDto>): BackendTaxSpecialDto => r.body),
    );
  }

  /** Path part for operation `projectTaxesTaxSpecialRetrieve()` */
  static readonly ProjectTaxesTaxSpecialRetrievePath = '/api/project_taxes/tax_special/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxSpecialRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesTaxSpecialRetrieve$Response(
    params: ProjectTaxesTaxSpecialRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxSpecialDto>> {
    return projectTaxesTaxSpecialRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxSpecialRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesTaxSpecialRetrieve(
    params: ProjectTaxesTaxSpecialRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendTaxSpecialDto> {
    return this.projectTaxesTaxSpecialRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxSpecialDto>): BackendTaxSpecialDto => r.body),
    );
  }

  /** Path part for operation `projectTaxesTaxSpecialUpdate()` */
  static readonly ProjectTaxesTaxSpecialUpdatePath = '/api/project_taxes/tax_special/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxSpecialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxSpecialUpdate$Response(
    params: ProjectTaxesTaxSpecialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxSpecialDto>> {
    return projectTaxesTaxSpecialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxSpecialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxSpecialUpdate(
    params: ProjectTaxesTaxSpecialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendTaxSpecialDto> {
    return this.projectTaxesTaxSpecialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxSpecialDto>): BackendTaxSpecialDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxSpecialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxSpecialUpdate$XWwwFormUrlencoded$Response(
    params: ProjectTaxesTaxSpecialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxSpecialDto>> {
    return projectTaxesTaxSpecialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxSpecialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxSpecialUpdate$XWwwFormUrlencoded(
    params: ProjectTaxesTaxSpecialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendTaxSpecialDto> {
    return this.projectTaxesTaxSpecialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxSpecialDto>): BackendTaxSpecialDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxSpecialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxSpecialUpdate$FormData$Response(
    params: ProjectTaxesTaxSpecialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxSpecialDto>> {
    return projectTaxesTaxSpecialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxSpecialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxSpecialUpdate$FormData(
    params: ProjectTaxesTaxSpecialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendTaxSpecialDto> {
    return this.projectTaxesTaxSpecialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxSpecialDto>): BackendTaxSpecialDto => r.body),
    );
  }

  /** Path part for operation `projectTaxesTaxSpecialDestroy()` */
  static readonly ProjectTaxesTaxSpecialDestroyPath = '/api/project_taxes/tax_special/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxSpecialDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesTaxSpecialDestroy$Response(
    params: ProjectTaxesTaxSpecialDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectTaxesTaxSpecialDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxSpecialDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesTaxSpecialDestroy(params: ProjectTaxesTaxSpecialDestroy$Params, context?: HttpContext): Observable<void> {
    return this.projectTaxesTaxSpecialDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectTaxesTaxSpecialPartialUpdate()` */
  static readonly ProjectTaxesTaxSpecialPartialUpdatePath = '/api/project_taxes/tax_special/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxSpecialPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxSpecialPartialUpdate$Response(
    params: ProjectTaxesTaxSpecialPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxSpecialDto>> {
    return projectTaxesTaxSpecialPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxSpecialPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxSpecialPartialUpdate(
    params: ProjectTaxesTaxSpecialPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendTaxSpecialDto> {
    return this.projectTaxesTaxSpecialPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxSpecialDto>): BackendTaxSpecialDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxSpecialPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxSpecialPartialUpdate$XWwwFormUrlencoded$Response(
    params: ProjectTaxesTaxSpecialPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxSpecialDto>> {
    return projectTaxesTaxSpecialPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxSpecialPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxSpecialPartialUpdate$XWwwFormUrlencoded(
    params: ProjectTaxesTaxSpecialPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendTaxSpecialDto> {
    return this.projectTaxesTaxSpecialPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxSpecialDto>): BackendTaxSpecialDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxSpecialPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxSpecialPartialUpdate$FormData$Response(
    params: ProjectTaxesTaxSpecialPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxSpecialDto>> {
    return projectTaxesTaxSpecialPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxSpecialPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxSpecialPartialUpdate$FormData(
    params: ProjectTaxesTaxSpecialPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendTaxSpecialDto> {
    return this.projectTaxesTaxSpecialPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxSpecialDto>): BackendTaxSpecialDto => r.body),
    );
  }
}
